module.exports = __webpack_public_path__ + "media/images/emoticons/two-e0d41e6271e27d9404f50deff137542e.gif";